import { useNavigate } from "react-router-dom";
import "./Home.css";
import { getCardsForSection, getUserPermissions } from "../config/cardRegistry";

const Home = () => {
    const navigate = useNavigate();
    const permissions = getUserPermissions();

    // Calcola il count dinamico per ogni sezione in base ai permessi
    const produttivitaCount = getCardsForSection("produttivita", permissions).length;
    const automazioneCount = getCardsForSection("automazione", permissions).length;
    const reportisticaCount = getCardsForSection("reportistica", permissions).length;

    const categories = [
        {
            id: 'reportistica',
            title: 'Reportistica',
            description: 'Dashboard Power BI per controllo di gestione, analisi HR e monitoraggio automezzi',
            count: reportisticaCount,
            label: 'dashboard',
            color: '#2E6DB1',
            path: '/reportistica',
            icon: (
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <line x1="18" y1="20" x2="18" y2="10"></line>
                    <line x1="12" y1="20" x2="12" y2="4"></line>
                    <line x1="6" y1="20" x2="6" y2="14"></line>
                </svg>
            )
        },
        {
            id: 'automazione',
            title: 'Automazione Processi',
            description: 'Strumenti per automatizzare operazioni quotidiane e flussi di lavoro aziendali',
            count: automazioneCount,
            label: 'automazioni',
            color: '#8FA830',
            path: '/automazione',
            icon: (
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                </svg>
            )
        },
        {
            id: 'produttivita',
            title: 'Produttività',
            description: 'Monitoring avanzato e facilitatori operativi per la gestione operativa quotidiana',
            count: produttivitaCount,
            label: 'strumenti',
            color: '#5F9279',
            path: '/produttivita',
            icon: (
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
                </svg>
            )
        },

        {
            id: 'ai-agents',
            title: 'AI Agents',
            description: 'Agenti AI intelligenti per analisi avanzata, automazione e supporto decisionale',
            count: 0,
            label: 'agenti',
            color: '#9333EA',
            path: '/ai-agents',
            icon: (
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
                    <path d="M2 17l10 5 10-5"></path>
                    <path d="M2 12l10 5 10-5"></path>
                </svg>
            )
        },
        {
            id: 'applicativi',
            title: 'Applicativi LF23',
            description: 'Suite applicativi gestionali e operativi per controllo flotte, contabilità e operations',
            count: 0,
            label: 'applicativi',
            color: '#F97316',
            path: '/applicativi',
            icon: (
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <rect x="3" y="3" width="7" height="7"></rect>
                    <rect x="14" y="3" width="7" height="7"></rect>
                    <rect x="3" y="14" width="7" height="7"></rect>
                    <rect x="14" y="14" width="7" height="7"></rect>
                </svg>
            )
        }
    ];

    return (
        <div className="home-container">
            <header className="page-header">
                <div className="header-content">
                    <div className="header-title">
                        <h2>Dashboard Principale</h2>
                        <p className="header-subtitle">Benvenuto nel portale operativo LF23</p>
                    </div>
                </div>
            </header>

            <div className="content-area-home">
                <div className="cards-grid-home">
                    {categories.map((category) => (
                        <div
                            key={category.id}
                            className={`section-card-home ${category.id}`}
                            onClick={() => navigate(category.path)}
                        >
                            <div className="decorative-circle-home"></div>
                            <div className="card-icon-home" style={{ color: category.color }}>
                                {category.icon}
                            </div>
                            <h3 className="card-title-home">{category.title}</h3>
                            <p className="card-description-home">{category.description}</p>
                            <div className="card-footer-home">
                                <span className="card-pages-home">
                                    {category.count} {category.label}
                                </span>
                                <div className="card-arrow-home" style={{ color: category.color }}>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Home;
